import React, { useContext, useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPause, faPlay } from "@fortawesome/free-solid-svg-icons";
import { previewStartInterval, startPreview } from "../../canvasUtils";
import { useSelector } from "react-redux";
import { CanvasContext } from "./PreviewCanvasContext";
import { useDispatch } from "react-redux";
import "./fabric-canvas.css";
import { setCurrentPreviewSlide } from "../../store/slides/slidesSlice";
import { setPreviewMode } from "../../store/common/uiSlice";

function PreviewControl({ onCloseSelect }) {
  const { slides } = useSelector((state) => state.slides);
  const { bgMusic, scriptVolume } = useSelector((state) => state.project);
  const dispatch = useDispatch();
  const [playing, setPlaying] = useState(false);
  const { canvas } = useContext(CanvasContext);
  const audioElRef = useRef(null);
  const backgroundAudioElRef = useRef(null);

  useEffect(() => {
    if (backgroundAudioElRef.current) {
      backgroundAudioElRef.current.volume = bgMusic.volume;
    }
    if (audioElRef.current) {
      audioElRef.current.volume = scriptVolume;
    }
  }, [backgroundAudioElRef, audioElRef, playing]);

  const previewClose = () => {
    if (previewStartInterval) {
      clearInterval(previewStartInterval);
    }
    if (backgroundAudioElRef.current && !backgroundAudioElRef.current.paused) {
      backgroundAudioElRef.current.pause();
      backgroundAudioElRef.current.currentTime = 0;
      backgroundAudioElRef.current.src = "";
    }
    if (audioElRef.current && !audioElRef.current.paused) {
      audioElRef.current.pause();
      audioElRef.current.currentTime = 0;
      audioElRef.current.src = "";
    }

    dispatch(setPreviewMode(false));
    dispatch(setCurrentPreviewSlide(0));
  };

  useEffect(() => {
    if (onCloseSelect) {
      previewClose();
    }
  }, [onCloseSelect, audioElRef, backgroundAudioElRef]);

  const handleComplete = () => setPlaying((prev) => false);

  const handlePlay = () => {
    const toStartPlay = !playing;
    setPlaying((prev) => toStartPlay);
    startPreview(
      0,
      dispatch,
      canvas,
      slides,
      audioElRef.current,
      handleComplete,
      !toStartPlay,
      backgroundAudioElRef
    );
  };

  return (
    <div>
      <div className=" fixed top-0 w-[100%] m-auto bg-yellow-200">
        <h1 className="text-lg  w-full text-center  ">
          The preview displays all assets, avatar voice, and music (if added),
          but avatar lip sync will be rendered in the final video to optimize
          performance.
        </h1>
      </div>
      {bgMusic?.file && playing && (
        <audio ref={backgroundAudioElRef} src={bgMusic?.file} autoPlay />
      )}
      <audio ref={audioElRef} />
      {!playing && (
        <button
          className="absolute inset-0 m-auto w-24 h-24 bg-red-700 text-white rounded-full hover:bg-blue-700 flex items-center justify-center z-50"
          style={{}}
          onClick={handlePlay}
        >
          <FontAwesomeIcon
            style={{ height: "3em", paddingLeft: `${playing ? "0" : "0.5em"}` }}
            icon={playing ? faPause : faPlay}
          />
        </button>
      )}
      <div className=" fixed bottom-0 w-[100%] m-auto bg-yellow-200">
        <h1 className="text-lg  w-full text-center  ">
          The preview displays all assets, avatar voice, and music (if added),
          but avatar lip sync will be rendered in the final video to optimize
          performance.
        </h1>
      </div>
    </div>
  );
}

export default PreviewControl;
